import { Check, X, FileText } from 'lucide-react';
import { adminApi } from '../../hooks/useAdminAi';

const card = 'bg-zinc-900 border-2 rounded-xl p-4';

export default function HelpDrafts({ drafts, reload, setMsg }) {
  const act = async (id, action, label) => {
    try { await adminApi(`/help-drafts/${id}/${action}`, { method: 'POST' }); setMsg(label); await reload(); } catch (e) { setMsg(e.message); }
  };
  return (
    <div className={card} style={{ borderColor: drafts.length ? '#FFD700' : '#27272a' }} data-testid="admin-ai-help-drafts">
      <h3 className="font-bold text-white mb-1 flex items-center gap-2"><FileText className="w-4 h-4 text-[#FFD700]" />Help page drafts {drafts.length > 0 && <span className="text-[#FFD700]">({drafts.length} waiting)</span>}</h3>
      <p className="text-xs text-zinc-500 mb-3">Tell Flip Buddy (signed in as you) or the Admin AI a new policy, and it drafts the Help Centre update here. Nothing goes live until you approve it.</p>
      {drafts.length === 0 && <p className="text-xs text-zinc-500">No drafts waiting.</p>}
      <div className="space-y-4">
        {drafts.map((d) => (
          <div key={d.draft_id} className="border border-zinc-800 rounded-lg p-3" data-testid={`help-draft-${d.draft_id}`}>
            <div className="flex flex-wrap items-center gap-2 text-xs mb-2">
              <span className="px-2 py-0.5 rounded-full font-bold bg-[#FFD700]/15 text-[#FFD700]">{d.is_new ? 'New page' : 'Update'}</span>
              <span className="font-mono text-zinc-400">/help/{d.slug}</span>
              <span className="text-zinc-600">via {d.source === 'flip_buddy' ? 'Flip Buddy' : 'Admin AI'}</span>
            </div>
            {d.reason && <p className="text-xs text-zinc-400 italic mb-2" data-testid={`help-draft-reason-${d.draft_id}`}>“{d.reason}”</p>}
            <div className={`grid gap-3 ${d.previous ? 'md:grid-cols-2' : ''}`}>
              {d.previous && <ArticleBox label="Live now" a={d.previous} muted />}
              <ArticleBox label={d.previous ? 'Proposed' : 'New page'} a={d} compareTo={d.previous} />
            </div>
            <div className="flex gap-2 mt-3">
              <button onClick={() => act(d.draft_id, 'publish', `Published — /help/${d.slug} is now live and Flip Buddy will use it.`)} className="flex items-center gap-1 px-4 py-2 rounded-full text-sm font-bold" style={{ background: '#00D26A', color: '#050505' }} data-testid={`help-draft-publish-${d.draft_id}`}><Check className="w-4 h-4" />Approve & publish</button>
              <button onClick={() => act(d.draft_id, 'reject', 'Draft rejected.')} className="flex items-center gap-1 px-4 py-2 rounded-full text-sm font-bold border border-zinc-700 text-zinc-300" data-testid={`help-draft-reject-${d.draft_id}`}><X className="w-4 h-4" />Reject</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ArticleBox({ label, a, muted, compareTo }) {
  const oldSet = new Set(compareTo?.body || []);
  return (
    <div className={`rounded-lg p-3 text-xs ${muted ? 'bg-black/40 text-zinc-500' : 'bg-black text-zinc-200'}`}>
      <div className="uppercase tracking-wide text-[10px] mb-1 text-zinc-500">{label}</div>
      <div className="font-bold text-sm mb-1">{a.title}</div>
      <div className="text-[#FFD700]/80 mb-2">{a.summary}</div>
      <div className="space-y-1.5">
        {a.body.map((p, i) => {
          const changed = compareTo && !oldSet.has(p);
          return <p key={i} className={changed ? 'border-l-2 border-[#00D26A] pl-2 text-white' : ''}>{p}</p>;
        })}
      </div>
    </div>
  );
}
